module.exports = __webpack_public_path__ + "static/media/COLA.d11999ba.JPG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/COLA.JPG
// module id = 1720
// module chunks = 1